function convertHourToDay(num) {
  let eq =
    "Converting " +
    num +
    "  hour to day: \n" +
    num +
    " * 0.04167 = ";
  let rep = num * 0.04167;
  return eq + rep.toFixed(4);
}

function convertHourToMinute(num) {
  let eq =
    "Converting " +
    num +
    " hour to minute: \n" +
    num +
    " * 60 = ";
  let rep = num * 60 ;
  return eq + rep.toFixed(2);
}

function convertHourToMonth(num) {
  let eq =
    "Converting " +
    num +
    " hour to month:  \n" +
    num +
    " * 0.00137 = ";
  let rep = num * 0.00137;
  return eq + rep.toFixed(5);
}

function convertHourToSecond(num) {
  let eq =
    "Converting " +
    num +
    " hour to second: \n" +
    num +
    " * 3600 = ";
  let rep = num * 3600;
  return eq + rep.toFixed(2);
}

function convertHourToWeek(num) {
  let eq =
    "Converting " +
    num +
    " hour to week: \n" +
    num +
    " * 0.00595 = ";
  let rep = num * 0.00595;
  return eq + rep.toFixed(5);
}

function convertHourToYear(num) {
  let eq =
    "Converting " +
    num +
    " hour to year: \n" +
    num +
    " * 0.00011407945862452115 = ";
  let rep = num * 0.00011407945862452115;
  return eq + rep.toFixed(6);
}

export {
  convertHourToDay,
  convertHourToYear,
  convertHourToWeek,
  convertHourToSecond,
  convertHourToMonth,
  convertHourToMinute
};
